export const USER_ROLE = 'user'
export const ADMIN_ROLE = 'admin'
export const HOTEL_OWNER_ROLE = 'hotelOwner'
